import {loadVisitorData, saveVisitorData} from './persistence';

const initData = {
  visitorId: undefined,
  lastVisit: undefined,
  timestamp: undefined,
  numVisits: 1
};

class ChatHistory {
  constructor(instanceId) {
    const visitHistory = this.getVisitHistory(instanceId);
    this.lastVisit = visitHistory.lastVisit;
    this.visitCount = visitHistory.visitCount;
  }

  historicalData(instanceId) {
    const data = loadVisitorData(instanceId);
    return data ? data : initData;
  }

  getVisitHistory(instanceId) {
    const currentTime = Date.now();
    const date = new Date(currentTime).toISOString().substring(0, 10);
    const data = this.historicalData(instanceId);

    if (!data.lastVisit) {
      data.lastVisit = date;
      data.timestamp = currentTime;
    } else if (data.lastVisit !== date) {
      data.lastVisit = date;
      data.timestamp = currentTime;
      data.numVisits += 1;
    }

    saveVisitorData(data, instanceId);

    return {
      lastVisit: data.timestamp,
      visitCount: data.numVisits
    };
  }
}

export default ChatHistory;



// WEBPACK FOOTER //
// ./chat-app/services/history.js